import { timeOf } from '../../../lib/dates';

/** Small formatting helpers shared by the Student 360 tabs. */

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** Parses an ISO date or datetime; date-only values are read as local dates. Null when unparseable. */
export function parseDate(iso: string | null | undefined): Date | null {
  if (!iso) return null;
  const d = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T00:00:00`) : new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "8 Sep" (design date), or "8 Sep 2025" with `year`. */
export function dayMonth(iso: string | null | undefined, year = false): string {
  const d = parseDate(iso);
  if (!d) return '—';
  return `${d.getDate()} ${MONTHS[d.getMonth()]}${year ? ` ${d.getFullYear()}` : ''}`;
}

/** "9 Oct, 19:42". */
export function dayMonthTime(iso: string | null | undefined): string {
  const d = parseDate(iso);
  if (!d) return '—';
  return `${d.getDate()} ${MONTHS[d.getMonth()]}, ${timeOf(d)}`;
}

/** "5–11 Oct" for a week starting on `weekOf` (or "28 Sep–4 Oct" across a month). */
export function weekRange(weekOf: string | null | undefined): string {
  const start = parseDate(weekOf);
  if (!start) return '';
  const end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6);
  return start.getMonth() === end.getMonth()
    ? `${start.getDate()}–${end.getDate()} ${MONTHS[end.getMonth()]}`
    : `${start.getDate()} ${MONTHS[start.getMonth()]}–${end.getDate()} ${MONTHS[end.getMonth()]}`;
}

/** "Male" from "male"; empty for no value. */
export function capitalize(s: string | null | undefined): string {
  if (!s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** "his" / "her" / "their" from the profile gender. */
export function possessive(gender: string | null | undefined): 'his' | 'her' | 'their' {
  const g = (gender ?? '').toLowerCase();
  return g === 'male' ? 'his' : g === 'female' ? 'her' : 'their';
}
